import { Action } from '../../actions';
import { UPDATE_BANNER_CREATIVE_DATA, UpdateBannerCreativeData } from '../../actions/creative';
import { bannerHasCreativeId, EditBannersState, MassActionId } from '../../typings/bannersEditState';

const updateBannerCreativeData = (state: EditBannersState, action: UpdateBannerCreativeData): EditBannersState => {
    const banner = state.banners[action.bannerId];

    if (!bannerHasCreativeId(banner)) {
        return state;
    }

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: {
                ...banner,
                creativeId: action.creative.id,
                errors: {
                    ...banner.errors,
                    creativeId: {
                        errors: []
                    }
                }
            }
        }
    };
};

export function creativeReducer(state: EditBannersState, action: Action): EditBannersState {
    switch (action.type) {
        case UPDATE_BANNER_CREATIVE_DATA:
            return action.bannerId === MassActionId.bannersEdit ? state : updateBannerCreativeData(state, action);

        default:
            return state;
    }
}
